const Contact = () => {
  return (
    <>
      <section className="page-intro">
        <div className="container">
          <h1>Contact Us</h1>
          <p>
            Ready to accelerate your digital initiatives? Reach out to Nexus IT for consultations, proposals, or
            partnership inquiries.
          </p>
        </div>
      </section>

      <section className="content-section">
        <div className="container contact-grid">
          <div className="contact-card">
            <span>Email</span>
            <a href="mailto:padmin@nexusitpk.com">padmin@nexusitpk.com</a> <br />
            <a href="mailto:info@nexusitpk.com">info@nexusitpk.com</a>
          </div>
          <div className="contact-card">
            <span>Phone</span>
            <a href="tel:+92515155854">+92 51 5155854</a>
          </div>
          <div className="contact-card">
            <span>Head Office</span>
            <p>
              Nexus Unified Solution &amp; Consultancy Services (Private) Limited
              <br />
              Islamabad, Pakistan
            </p>
          </div>
        </div>
      </section>

      <section className="section alt">
        <div className="container">
          <div className="cta-banner">
            <div>
              <h2>Let’s Build What’s Next</h2>
              <p>Share your project requirements and our consultants will connect with tailored insights.</p>
            </div>
            <a className="btn btn-white" href="mailto:info@nexusitpk.com">
              Email Nexus IT
            </a>
          </div>
        </div>
      </section>
    </>
  );
};

export default Contact;
